var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.984,
    height: 20.171,
    viewBox: "0 0 15.984 20.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-map",
    d: "M12,22h0a12.816,12.816,0,0,0,7.988-12,7.992,7.992,0,1,0-15.98,0A12.816,12.816,0,0,0,12,22ZM10,10a2,2,0,1,1,2,2A2,2,0,0,1,10,10Z",
    transform: "translate(-4.006 -1.829)",
    fill: "#00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressMap);
export default __webpack_public_path__ + "static/media/address-map.8be80ffffb7d79c609474ef8c70bf77e.svg";
export { ForwardRef as ReactComponent };